<rt-dropdown *ngIf="isCandidate()">
  <rt-dropdown-header>
    {{ 'rtu.common.candidate' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item class="info-item" layout layout-vertical>
    <div class="info-wrap" layout layout-align-items-center>
      <rt-avatar
        [type]="tag.candidate!.hasAvatar ? 'image' : 'initials'"
        [initials]="tag.candidate!.initials"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="tag.candidate!.photoThumbUrl"
      >
      </rt-avatar>
      <div class="text-wrap" layout layout-vertical>
        <rt-heading>
          {{ tag.candidate!.name }}
        </rt-heading>
        <div
          *ngIf="tag.candidate!.placements && tag.candidate!.placements.length"
          class="text"
          layout
        >
          <span *ngIf="tag.candidate!.placements[0].offer">
            {{ tag.candidate!.placements[0].offer.title }}
          </span>
        </div>
      </div>
    </div>
  </rt-dropdown-item>
  <rt-dropdown-header [isSubheading]="true">
    {{ 'rtu.mailbox.send_mail_to' | translate }}
  </rt-dropdown-header>

  <ng-container *ngIf="tag.candidate!.emails.length">
    <rt-dropdown-item
      *ngFor="let email of getAllEmailsFromTag(); trackBy: trackByEmail"
      (click)="select(email)"
    >
      <div class="item-content-email" [style.max-width]="'80%'">
        <rt-truncate>{{ email }}</rt-truncate>
      </div>

      <rt-icon
        prefix
        *ngIf="isEmailActive(email)"
        name="check"
        size="medium"
        colorToken="colorIconPrimaryDefault"
      ></rt-icon>
    </rt-dropdown-item>
  </ng-container>
  <ng-container *ngIf="!tag.candidate!.emails.length && tag.email">
    <rt-dropdown-item>
      <div class="item-content-email" [style.max-width]="'80%'">
        <rt-truncate>{{ tag.email }}</rt-truncate>
      </div>

      <rt-icon prefix name="check" size="medium" colorToken="colorIconPrimaryDefault"> </rt-icon>
    </rt-dropdown-item>
  </ng-container>
  <rt-dropdown-item (click)="showCandidate()">
    {{ 'rtu.mailbox.go_to_profile' | translate }}
  </rt-dropdown-item>
</rt-dropdown>

<rt-dropdown *ngIf="isAdmin()">
  <rt-dropdown-header>
    {{ 'rtu.common.team_member' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item class="info-item" layout layout-vertical>
    <rt-avatar
      prefix
      [type]="tag.admin!.hasAvatar ? 'image' : 'initials'"
      [size]="'base'"
      [shape]="'oval'"
      [imageSrc]="tag.admin!.photoThumbUrl"
      [initials]="tag.admin!.initials"
    >
    </rt-avatar>
    <div class="text-wrap" layout layout-vertical>
      <rt-heading>{{ tag.name }}</rt-heading>
      <div class="text" layout>
        <span>{{ tag.email }}</span>
      </div>
    </div>
  </rt-dropdown-item>
</rt-dropdown>

<rt-dropdown *ngIf="!isCandidate() && !isAdmin()">
  <rt-dropdown-item class="info-item" layout layout-vertical>
    <div class="info-wrap" layout layout-align-items-center>
      <div class="text-wrap" layout layout-vertical>
        <rt-heading>{{ tag.name }}</rt-heading>
        <div class="text" layout>
          <span>{{ tag.email }}</span>
        </div>
      </div>
    </div>
  </rt-dropdown-item>
</rt-dropdown>
